import { CardsViewAttributeOption, CardsViewSortOption } from "@organisms/ObjectsView/CardsView/CardsView.types"

export const VENDOR_CREDIT_CARDS_VIEW_ATTRIBUTE_OPTIONS: CardsViewAttributeOption<VendorCredit>[] = [
    { name: "subtotal", label: "Total" },
    { name: "amount_remaining", label: "Remaining" },
    { name: "date_issued", label: "Issued" },
    { name: "last_modified_at", label: "Last Modified" },
    { name: "labels", label: "Labels" },
]

// Only the fields the vendor credit endpoint can order by; applied and remaining are computed per read.
export const VENDOR_CREDIT_CARDS_VIEW_SORT_OPTIONS: CardsViewSortOption<VendorCredit>[] = [
    { name: "id", label: "ID" },
    { name: "vendor_name", label: "Vendor" },
    { name: "vendor_credit_note_id", label: "Vendor Credit Note ID" },
    { name: "status_label", label: "Status" },
    { name: "subtotal", label: "Total" },
    { name: "date_issued", label: "Issued" },
    { name: "last_modified_at", label: "Last Modified" },
]
